// extracted by mini-css-extract-plugin
module.exports =  {"Section":"Section__rgXwD","title":"title__ocIOd"};